import Backend from '../backend';
import {ShoppingCart} from './checkout-flow/shopping-cart';
import {inject, observable, TaskQueue} from 'aurelia-framework';
import {Redirect, Router} from 'aurelia-router';

@inject(ShoppingCart, Backend, Router, TaskQueue)
export class SingleProductCatalogScreen {
  element;
  backend;
  shoppingCart;
  router;
  taskQueue;

  chosenProducts = []; // Bound to sub product component
  initValues = {};
  @observable({changeHandler: 'selectedProductCategorySeoKeyChanged'})
  selectedProductCategorySeoKey;
  crateChoiceModalComponentRef;

  constructor(shoppingCart, backend, router, taskQueue) {
    this.shoppingCart = shoppingCart;
    this.backend = backend;
    this.router = router;
    this.taskQueue = taskQueue;
  }

  canActivate(params, routeConfig) {
    this.selectedProductCategorySeoKey = params.productCategorySeoKey;
    return this.shoppingCart.load()
      .then(() => {
        // Has user already selected a crate?
        let info = this.shoppingCart.getInfo();
        if (info.crateProduct.productId) {
          // If so, go to checkout flow.
          return new Redirect('checkout-flow', {step: 'first'});
        } else {
          // if not, return 'yes, we can activate this screen'
          return true;
        }
      })
      .then(() => {
        if (this.selectedProductCategorySeoKey == null) {
          routeConfig.navModel.setTitle(routeConfig.title);
        } else {
          this.backend.ProductCategoryQueryHandler_handle({productCategoryIdOrSeoKey: this.selectedProductCategorySeoKey})
            .then(result => {
              // SEO: Title
              routeConfig.navModel.setTitle(result.productCategoryName + ' | ' + routeConfig.title);
            });
        }
      });
  }

  activate(params) {
    return Promise.all([
      this.backend.CmsFragmentPublicQueryHandler_handle({items: [
            {cmsFragmentKey: "single_product_catalog__section1"},
          ]})
        .then(result => this.cmsFragments = result),
    ]);
  }

  bind() {
    // Debug: useful for development of modal content
    // this.crateChoiceModalRef.open();
  }

  selectedProductCategorySeoKeyChanged() {
    this.router.navigateToRoute('single-product-catalog', {productCategorySeoKey: this.selectedProductCategorySeoKey});
  }

  buy(product) {
    const chosenProducts = [
      {
        productId: product.productId,
        quantity: 1
      }
    ];
    // Show crate choice modal
    this.taskQueue.queueMicroTask({
      call: () => {
        this.crateChoiceModalComponentRef.show(chosenProducts);
      }
    });
  }
}
